import { gql } from '@apollo/client';

const GET_INDUSTRY_APPRAISAL_VIEW = gql`
  query GetAppraisalView($appraisalViewRequest: [AppraisalViewRequest]) {
    appraisalComparisonView(appraisalViewRequest: $appraisalViewRequest) {
      PracticeAreas {
        Ids
        Name
        Acronym
        AggregatePercentageExact
        DefaultLevel
        IncludeHigherLevels
        IncludeHigherProgramYears
        Year
        AggregatePercentage {
          Name
          Results
          Cnt
        }
        Practices {
          Level
          NumberInLevel
          PracticeName
          Name
          Satisfied
          Partial
          Deficient
        }
      }
    }
  }
`;

export default GET_INDUSTRY_APPRAISAL_VIEW;
